"use strict";

window.addEventListener('DOMContentLoaded', () => {
	gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
	const el = document.querySelector('.js-checktool');
	if (el) {
		new CheckTool(el);
	}
	
	const images = document.querySelectorAll('.c-illust img');
	for (let img of images) {
		img.style.setProperty('--w', img.getAttribute('width') * .5);
	}
});

window.addEventListener('load', () => {
	const landing = document.querySelector('.l-modal.landingmovie');
	landing.classList.add('is-active', 'is-anim');
	
	const overlay = landing.querySelector('.modal_overlay');
	const close = landing.querySelector('.modal_close');
	const contents = landing.querySelector('.modal_contents');
	const video = landing.querySelector('video');
	
	contents.addEventListener('click', () => {
		video.paused ? video.play() : video.pause();
	});
	
	[overlay, close].forEach((el) => {
		el.addEventListener('click', () => {
			if (!video.paused) video.pause();
			closeLanding();
		}, { once: true });
	});
	
	video.addEventListener('ended', () => {
		closeLanding();
	}, { once: true });
	
	function closeLanding() {
		landing.classList.replace('is-active', 'is-anim');
		landing.addEventListener('transitionend', () => {
			landing.parentNode.removeChild(landing);
		}, { once: true });
	}
});

class CheckMotion {
	constructor(el) {
		this.curItem = null;
		const items = el.querySelectorAll('.item');
		items.forEach((item) => this.setup(item));
	}
	setup(item) {
		const radio = item.querySelector('input[type="radio"]');
		radio.addEventListener('change', (e) => {
			item.classList.add('is-anim');
			this.curItem = item;
		});
		item.addEventListener('animationend', () => {
			item.classList.remove('is-anim');
		});
		radio.addEventListener('click', (e) => {
			if (this.curItem) this.curItem.classList.add('is-anim');
		});
	}
}
class ModalContents {
	constructor(el) {
		this.isOpened = false;
		this.modal = document.querySelector('.check_result');
		this.type = this.modal.dataset.type;
		
		this.closer = this.modal.querySelector('.modal_close');
		this.overlay = this.modal.querySelector('.modal_overlay');
		this.container = this.modal.querySelector('.result_container');
		this.relations = [this.closer, this.overlay, this.container];
		
		for (let el of this.relations) {
			el.addEventListener('transitionend', () => {
				el.classList.remove('is-anim');
				
				// 閉じた後にモーダルを非活性にする
				if (!this.isOpened && el === this.overlay) {
					this.modal.classList.remove('is-active');
				}
			});
		}
		this.setupUi();
	}
	setupUi() {
		// コンテンツ部分以外をクリックしたら閉じる
		this.modal.addEventListener('click', (e) => {
			if (this.isOpened && !e.target.closest('.result_container')) {
				this.close();
			}
		});
		
		// フォーカスをモーダルの中に閉じ込める
		this.closer.addEventListener('keydown', (e) => {
			if (this.isOpened && e.code === 'Tab' && e.shiftKey) {
				e.preventDefault();
			}
		});
		this.modal.addEventListener('focusout', (e) => {
			if (this.isOpened && e.relatedTarget) {
				if (e.relatedTarget.closest('[aria-modal]') === null) {
					e.preventDefault();
					this.closer.focus({ focusVisible: true });
				}
			}
		});
	}
	open() {
		this.isOpened = true;
		this.modal.classList.add('is-active');
		
		if (this.type === 'modal') {
			this.modal.ariaModal = true;
			for (let el of this.relations) {
				el.classList.add('is-open', 'is-anim');
			}
		}
		if (this.type === 'pulldown') {
			this.container.classList.add('is-open', 'is-anim');
			this.container.style.height = '0px';
			const firstRect = this.container.firstElementChild.getBoundingClientRect();
			const lastRect = this.container.lastElementChild.getBoundingClientRect();
			const openHeight = lastRect.bottom - firstRect.top;
			this.container.style.height = openHeight + 'px';
			this.container.addEventListener('transitionend', () => {
				this.container.style.height = '';
			}, { once: true });
		}
		
		this.closer.focus({ focusVisible: true });
	}
	close() {
		this.isOpened = false;
		if (this.type === 'modal') {
			this.modal.ariaModal = false;
			for (let el of this.relations) {
				el.classList.replace('is-open', 'is-anim');
			}
		}
		if (this.type === 'pulldown') {
			const firstRect = this.container.firstElementChild.getBoundingClientRect();
			const lastRect = this.container.lastElementChild.getBoundingClientRect();
			const openHeight = lastRect.bottom - firstRect.top;
			this.container.style.height = openHeight + 'px';
			this.container.classList.replace('is-open', 'is-anim');
			setTimeout(() => {
				this.container.style.height = '0px';
				this.container.addEventListener('transitionend', () => {
					this.container.style.height = '';
				}, { once: true });
			}, 20);
		}
	}
}
class CheckTool {
	constructor(el) {
		this.insertContents(el);
		this.setup(el);
		
		const progress = el.querySelector('.check_progress');
		if (progress) {
			let shift = 24;
			let bottom = 0;
			if ((window.matchMedia('(max-width:767px)').matches)) {
				const menu = document.querySelector('.l-menu');
				shift = menu.clientHeight + 24;
				bottom = shift + progress.clientHeight + 24;
			}
			ScrollTrigger.create({
				trigger: progress,
				start: `bottom+=${shift}px bottom`,
				endTrigger: '.check_list',
				end: `bottom bottom-=${bottom}px`,
				pinSpacing: false,
				pin: true,
				onEnter: () => progress.classList.add('is-active'),
				onLeaveBack: () => progress.classList.remove('is-active'),
			});
		}
	}
	setup(el) {
		const result = document.querySelector('.check_result');
		const modalContents = new ModalContents(el);
		const radios = el.querySelectorAll('input[type="radio"]');
		const answers = el.querySelectorAll('.check_a');
		const totalButton = el.querySelector('.check_sum');
		const progress = el.querySelector('.check_progress');
		
		if (modalContents.type === 'pulldown') {
			totalButton.classList.add('is-pulldown');
		}
		
		// モーションをつける
		for (let answer of answers) {
			new CheckMotion(answer);
		}
		
		for (let radio of radios) {
			radio.addEventListener('change', (e) => {
				// MEMO: 過去3ヶ月間で体重の減少がありましたか？だったらvalueをresuleに保持
				const q = e.target.closest('.check_item').id;
				if (q === 'qb') result.dataset[q] = e.target.value;
				
				// 合計ボタンの活性化
				this.validation(answers, answers.length, totalButton, progress);
				
				// ターゲット設問を非活性化
				if (radio.dataset.target) this.disabling(el, radio, totalButton);
				
				// MEMO: プルダウンが開いてる時に答えを変えたらプルダウン閉じる
				if (modalContents.isOpened && modalContents.type === 'pulldown') modalContents.close();
			});
		}
		totalButton.addEventListener('animationend', () => {
			totalButton.classList.remove('is-anim');
		});
		if (progress) {
			progress.addEventListener('animationend', () => {
				progress.classList.remove('is-anim');
			});
		}
		
		// 合計を計算する
		const totalOutput = modalContents.modal.querySelector('.check_total .n');
		totalButton.addEventListener('click', () => {
			let total = 0;
			for (let answer of answers) {
				if (answer.querySelector('input:checked')) {
					total += parseInt(answer.querySelector('input:checked').value);
				}
			}
			totalOutput.value = total;
			let lv = total >= 12 ? '3' : total >= 8 ? '2' : '1';
			modalContents.modal.dataset.lv = `lv${lv}`;
			modalContents.open();
		});
	}
	disabling(el, radio, totalButton) {
		const list = el.querySelector('.check_list');
		const self = radio.closest('.check_item');
		const target = list.querySelector('.check_item#q' + radio.dataset.target);
		
		if (radio.dataset.point !== '-') {
			self.classList.remove('is-disabled');
			target.classList.add('is-disabled');
			const unanswered = target.querySelector('input[data-point="-"]');
			if (unanswered) {
				unanswered.checked = true;
				totalButton.disabled = false;
				totalButton.classList.add('is-anim');
			}
		} else {
			self.classList.add('is-disabled');
			target.classList.remove('is-disabled');
			totalButton.disabled = true;
			totalButton.classList.add('is-anim');
		}
	}
	validation(answers, length, totalButton, progress) {
		let count = 0;
		answers.forEach((answer, index) => {
			if (answer.querySelector('input:checked')) {
				count++;
			}
		});
		if (progress) {
			progress.classList.add('is-anim');
			progress.querySelector('.count').textContent = length - count;
		}
		if (length <= count) {
			totalButton.disabled = false;
			totalButton.classList.add('is-anim');
			if (progress) {
				progress.classList.add('is-hide');
			}
		}
	}
	insertContents(el) {
		const list = el.querySelector('.check_list');
		const data = this.contentsData();
		let html = '';
		data.forEach((d, i) => {
			html += `<div id="q${d.id}" class="check_item">`;
			html += `<dt class="check_q">${d.q}</dt>`;
			html += `<dd class="check_a">`;
			html += `<ul class="list" style="--col:${d.a.length}">`;
			d.a.forEach((a, j) => {
				const val = typeof a.point !== 'string' ? a.point : 0;
				html += `<li class="item"><label title="${a.tip}">`;
				html += `<input type="radio" name="q${d.id}" value="${val}" data-point="${a.point}"`;
				if (d.target !== undefined) {
					html += ` data-target="${d.target}"`;
				}
				html += `><span class="point"><span class="num">${a.point}</span><span class="tip">${a.tip}</span></span>`;
				html += `</label></li>`;
			});
			html += `</ul>`;
			html += `</dd>`;
			html += `</div>`;
		});
		list.innerHTML = html;
	}
	contentsData() {
		return [
			{
				"id": "a",
				"q": "過去3ヶ月間で食欲不振、消化器系の問題、そしゃく・嚥下困難などで食事量が減少しましたか？",
				"a": [
					{ "point": 0, "tip": "著しい食事量の減少" },
					{ "point": 1, "tip": "中等度の食事量の減少" },
					{ "point": 2, "tip": "食事量の減少なし" }
				]
			}, {
				"id": "b",
				"q": "過去3ヶ月間で体重の減少がありましたか？",
				"a": [
					{ "point": 0, "tip": "3kg以上の減少" },
					{ "point": 1, "tip": "わからない" },
					{ "point": 2, "tip": "1〜3kgの減少" },
					{ "point": 3, "tip": "体重減少なし" }
				]
			}, {
				"id": "c",
				"q": "自力で歩けますか？",
				"a": [
					{ "point": 0, "tip": "寝たきりまたは車椅子を常時使用" },
					{ "point": 1, "tip": "ベッドや車椅子を離れられるが、歩いて外出はできない" },
					{ "point": 2, "tip": "自由に歩いて外出できる" }
				]
			}, {
				"id": "d",
				"q": "過去3ヶ月間で精神的ストレスや急性疾患を経験しましたか？",
				"a": [
					{ "point": 0, "tip": "はい" },
					{ "point": 2, "tip": "いいえ" }
				]
			}, {
				"id": "e",
				"q": "神経・精神的問題の有無",
				"a": [
					{ "point": 0, "tip": "強度認知症またはうつ状態" },
					{ "point": 1, "tip": "中程度の認知症" },
					{ "point": 2, "tip": "精神的問題なし" }
				]
			}, {
				"id": "f1",
				"target": "f2",
				"q": "BMI（体重(kg)÷身長(m)²）",
				"a": [
					{ "point": "-", "tip": "未回答" },
					{ "point": 0, "tip": "BMIが19未満" },
					{ "point": 1, "tip": "BMIが19以上、21未満" },
					{ "point": 2, "tip": "BMIが21以上、23未満" },
					{ "point": 3, "tip": "BMIが23以上" }
				]
			}, {
				"id": "f2",
				"target": "f1",
				"q": "ふくらはぎの周囲長(cm):CC",
				"a": [
					{ "point": "-", "tip": "未回答" },
					{ "point": 0, "tip": "31cm未満" },
					{ "point": 3, "tip": "31cm以上" }
				]
			}
		];
	}
}
